import { getUserIdentity } from "../../../../services/identity";

const getUsersIdentity = async () => {
  try {
    const { customerId } = await getUserIdentity();

    return customerId;
  } catch (e) {
    return undefined;
  }
};

export default getUsersIdentity;
